import cls from 'classnames';
import { groupBy, maxBy, toArray } from 'lodash';
import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';
import { ActionBarButton } from 'skrit-web-framework/components/buttons';
import Button from 'skrit-web-framework/components/buttons-new/Button';
import ByteImage from 'skrit-web-framework/components/ByteImage';
import Drawer from 'skrit-web-framework/components/Drawer';
import { CheckboxSKR } from 'skrit-web-framework/components/inputs';
import SelectSKR from 'skrit-web-framework/components/selects/SelectSKR';
import Spinner from 'skrit-web-framework/components/Spinner';
import {
    ACCIONES_ROW,
    ESTADOS_FORM,
    SERVER,
    TEXTBOX,
} from 'skrit-web-framework/constantes';
import Ficha from 'skrit-web-framework/fichas';
import translate from 'skrit-web-framework/translator';
import {
    formatCurrency,
    getBreakpoints,
    smartFetch,
    swalMsg,
} from 'skrit-web-framework/utils';
import AnyadirArticulo from '../fichas/cesta/AnyadirArticulo';
import {
    FICHAS,
    FORMS,
    GRIDS,
    HISTORICO_MOTOSCAT,
    ORDEN,
} from '../utils/ConstantesComunes';
// import {
//     sortArtByMarca,
//     sortArtByNeto,
//     sortArtByPrecio,
//     sortArtByReferencia,
//     sortArtByStock,
//     sortByMarca,
//     sortByStock,
// } from '../utils/sort';
import { windowsAlert } from '../utils/utils';
import Pagination from 'react-js-pagination';

const filtroSinMarca = [ORDEN.PRECIO, ORDEN.REFERENCIA, ORDEN.NETO];

const mapStateToProps = (state) => {
    const config = state.config || {};
    return {
        ...state.motoscat,
        motoscat: state.motoscat,
        esCliente: config.EsCliente,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeCliente(reg) {
            dispatch({
                type: 'CHANGE_CLIENTE_SEL',
                id: FORMS.ARTICULOS,
                clienteSel: reg,
            });
        },
        changeLineasCesta(reg) {
            dispatch({ type: 'CHANGE_LINEAS_CESTA', lineas: reg });
        },
        setReferencia(referencia) {
            dispatch({
                type: 'SET_REFERENCIA',
                referencia,
            });
        },
        setMotor(idMotor, motor) {
            dispatch({
                type: 'SET_MOTOR',
                idMotor,
                motor,
            });
        },
        deleteMotor() {
            dispatch({
                type: 'SET_MOTO',
                idMarca: null,
                idModelo: null,
                idMotor: null,
                idMarcaArticulo: null,
                marca: '',
                modelo: '',
                motor: '',
                cc: '',
            });
        },
        deleteMarca() {
            dispatch({
                type: 'SET_MARCA_ARTICULO',
                idMarca: null,
                idModelo: null,
                idMotor: null,
                idMarcaArticulo: null,
                marca: '',
                modelo: '',
                motor: '',
            });
        },
    };
};

class Articulos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: null,
            ini: null,
            articlesSorted: null,
            idMotor: null,
            isFetching: false,
            currentPage: 1,
            maxArticulos: 30,
            totalProducts: 0,
            maxPages: 0,
            codigo: '',
            busquedaExacta: false,
            openArticuloCesta: false,
            ordenar: [
                { id: ORDEN.STOCK, text: translate('stock') },
                { id: ORDEN.PRECIO, text: translate('precio') },
                { id: ORDEN.MARCA, text: translate('marca') },
                { id: ORDEN.REFERENCIA, text: translate('referencia') },
                { id: ORDEN.NETO, text: translate('neto') },
            ],
            orderId: ORDEN.MARCA,
            fichaStock: {
                open: false,
                reg: null,
            },
            fichaOEM: {
                open: false,
                reg: null,
            },
            fichaEqv: {
                open: false,
                reg: null,
            },
            filtros: {
                hideBrands: false,
                compactArticle: false,
                showLessPrice: false,
            },
            marcasFiltradas: [],
            article: null,
            marcasCruzadas: [],
            otrasMarcas: [],
            familiasArticulos: [],
            acordeonMarcas: false,
            acordeonMarcasNotCross: false,
            acordeonFechasMontaje: false,
            acordeonGruposMontaje: false,
            checkFilter: {
                brand: true,
                brandNotCross: true,
                dates: true,
                assembly: true,
            },
            filterBrand: [],
            filterNotCrossBrand: [],
            filterDate: [],
            filterAssembly: [],
            modalImage: {
                open: false,
                refSkrit: null,
            },
        };
    }

    componentDidMount() {
        this.setState({ isFetching: true }, () => {
            this.getArticle();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            idMotor,
            referencia,
            motoscat,
            grupoMontaje,
            idMarcaArticulo,
            codigo,
        } = this.props;
        const { currentPage, orderId } = this.state;
        //Cambio de moto
        if (
            Array.isArray(grupoMontaje) &&
            JSON.stringify(prevProps.grupoMontaje) !==
                JSON.stringify(grupoMontaje)
        ) {
            this.props.setReferencia('');
            this.setState(
                (prevState) => ({
                    ...prevState,
                    isFetching: true,
                    rows: null,
                    ini: null,
                    articulos: null,
                    codigo: null,
                    articlesSorted: [],
                    filterBrand: [],
                    filterDate: [],
                    filterAssembly: [],
                    currentPage: 1,
                    maxPages: 1,
                }),
                () => this.getArtByMoto()
            );
        }
        // Distinta marca de Moto
        if (prevProps.idMarcaArticulo !== idMarcaArticulo) {
            this.props.deleteMotor();
            this.props.setReferencia('');
            this.setState(
                (prevState) => ({
                    ...prevState,
                    isFetching: true,
                    rows: null,
                    ini: null,
                    articulos: null,
                    codigo: null,
                    articlesSorted: [],
                    filterNotCrossBrand: [],
                    filterBrand: [],
                    filterDate: [],
                    filterAssembly: [],
                    currentPage: 1,
                    maxPages: 1,
                }),
                () => this.getArtByMarca()
            );
        }
        //Distinta referencia en el buscador
        if (
            (referencia !== prevProps.referencia &&
                referencia !== null &&
                referencia !== '' &&
                codigo !== prevState.codigo) ||
            (motoscat &&
                motoscat.stateEquiv &&
                prevProps.motoscat &&
                prevProps.motoscat.stateEquiv &&
                motoscat.stateEquiv !== prevProps.motoscat.stateEquiv &&
                referencia !== null &&
                referencia !== '')
        ) {
            this.props.deleteMotor();
            this.props.deleteMarca();
            this.setState(
                (prevState) => ({
                    ...prevState,
                    isFetching: true,
                    rows: null,
                    ini: null,
                    articulos: null,
                    articlesSorted: [],
                    filterNotCrossBrand: [],
                    filterBrand: [],
                    filterDate: [],
                    filterAssembly: [],
                    codigo: referencia,
                    marcasCruzadas: [],
                    familiasArticulos: [],
                    otrasMarcas: [],
                }),
                () => this.getArtByRef()
            );
        }
        if (
            idMotor == null &&
            prevProps &&
            prevProps.idMotor &&
            idMotor !== prevProps.idMotor
        ) {
            this.setState({
                rows: null,
                ini: null,
                marcasCruzadas: [],
                familiasArticulos: [],
                otrasMarcas: [],
                articulos: null,
                articlesSorted: [],
                filterBrand: [],
                filterNotCrossBrand: [],
                filterDate: [],
                filterAssembly: [],
                maxPages: 1,
            });
        }
        // Cambia de cliente
        if (
            motoscat &&
            motoscat.cliente &&
            prevProps.motoscat &&
            prevProps.motoscat.cliente &&
            motoscat.cliente.CODIGO !== prevProps.motoscat.cliente.CODIGO
        ) {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    isFetching: true,
                    marcasCruzadas: [],
                    familiasArticulos: [],
                    otrasMarcas: [],
                }),
                () => {
                    this.getArticle();
                }
            );
        }
        // Buscar articulos OEM
        if (
            motoscat &&
            motoscat.OEM &&
            prevProps.motoscat &&
            prevProps.motoscat.OEM &&
            motoscat.OEM !== prevProps.motoscat.OEM
        ) {
            this.getArtByOEM(motoscat.OEM.codigoOEM, motoscat.OEM.marcaOEM);
        }
        if (
            prevState.currentPage !== currentPage ||
            prevState.orderId !== orderId
        ) {
            this.setState({ isFetching: true }, () => {
                this.getArticle();
            });
        }
        if (prevState.orderId !== orderId) {
            this.setState({ currentPage: 1 });
        }
    }

    //Remove if <Input component works
    // handleKeyDown = (e) => {
    //     this.setState(
    //         {
    //             isFetching: true,
    //             marcasCruzadas: [],
    //             familiasArticulos: [],
    //             otrasMarcas: [],
    //         },
    //         () => this.getArtByRef()
    //     );
    // };

    handleSort = (value) => {
        const { articlesSorted } = this.state;
        if (
            articlesSorted === null ||
            (Array.isArray(articlesSorted) && articlesSorted.length === 0)
        )
            return;
        this.setState({
            orderId: value.id,
        });
    };

    handleRemoveMarcas = (e) => {
        const { filtros, articlesSorted, orderId } = this.state;
        if (!filtroSinMarca.includes(orderId) && articlesSorted != null) {
            this.setState({
                filtros: {
                    ...filtros,
                    hideBrands: !filtros.hideBrands,
                },
            });
        }
        e.preventDefault();
        e.stopPropagation();
    };

    handleErrorSearch(msg) {
        let error = msg;
        if (error == null || error === '') {
            error = translate('no_articles');
        }
        this.setState(
            {
                isFetching: false,
                rows: null,
                ini: null,
                marcasCruzadas: [],
                familiasArticulos: [],
                otrasMarcas: [],
                check: {
                    cruzadas: true,
                    otras: true,
                },
                articulos: null,
            },
            () => swalMsg('error', error)
        );
    }

    handleImage = (refSkrit) => (e) => {
        this.setState({
            modalImage: {
                open: true,
                refSkrit,
            },
        });
    };

    handleCloseModal = (e) => {
        this.setState({
            modalImage: {
                open: false,
                refSkrit: null,
            },
        });
    };

    handleChangePage = (pageNumber) => {
        this.setState((prevState) => ({
            ...prevState,
            currentPage: pageNumber,
        }));
    };

    // handleCheckFamilias(value, element) {
    //     const {
    //         articlesSorted,
    //         filtros,
    //         familiasArticulos,
    //         marcasCruzadas,
    //         otrasMarcas,
    //         orderId,
    //     } = this.state;
    //     let familiasChk = familiasArticulos.map((el) => {
    //         if (el.FART_CODIGO === element.FART_CODIGO) {
    //             return {
    //                 ...el,
    //                 isChecked: value,
    //             };
    //         }
    //         return el;
    //     });
    //     let familasShown = familiasChk
    //         .filter((el) => el.isChecked)
    //         .map((el) => el.FART_CODIGO);
    //     let marcasCruzadasShown = marcasCruzadas
    //         .filter((el) => el.isChecked)
    //         .map((el) => el.codigo);
    //     let otrasMarcasShown = otrasMarcas
    //         .filter((el) => el.isChecked)
    //         .map((el) => el.codigo);
    //     let newarticlesSorted = [];
    //     if (filtros.hideBrands || filtroSinMarca.includes(orderId)) {
    //         //Filtrar por familia (grupo de montaje)
    //         newarticlesSorted = articlesSorted[0].articulos.map((el) => {
    //             return {
    //                 ...el,
    //                 show: familasShown.includes(el.FART_CODIGO),
    //             };
    //         });
    //         //Filtrar por marcas
    //         newarticlesSorted = newarticlesSorted.map((el) => {
    //             if (el.show) {
    //                 return {
    //                     ...el,
    //                     show:
    //                         marcasCruzadasShown.includes(
    //                             el.ART_ID_MARCA_ARTICULO
    //                         ) ||
    //                         otrasMarcasShown.includes(el.ART_ID_MARCA_ARTICULO),
    //                 };
    //             }
    //             return el;
    //         });
    //         newarticlesSorted = [{ articulos: newarticlesSorted, show: true }];
    //     } else {
    //         //Filtrar por familia (grupo de montaje)
    //         newarticlesSorted = articlesSorted.map((el) => {
    //             if (el.show) {
    //                 return {
    //                     ...el,
    //                     articulos: el.articulos.map((el) => {
    //                         return {
    //                             ...el,
    //                             show: familasShown.includes(el.FART_CODIGO),
    //                         };
    //                     }),
    //                 };
    //             }
    //             return el;
    //         });
    //     }
    //     this.setState({
    //         articlesSorted: newarticlesSorted,
    //         familiasArticulos: familiasChk,
    //     });
    // }

    // handleCheckOtrasMarcas(value, element) {
    //     const { otrasMarcas, articlesSorted, filtros, orderId } = this.state;
    //     let newarticlesSorted = [];
    //     if (filtros.hideBrands || filtroSinMarca.includes(orderId)) {
    //         newarticlesSorted = articlesSorted[0].articulos.map((el) => {
    //             if (el.ART_ID_MARCA_ARTICULO === element.codigo) {
    //                 return {
    //                     ...el,
    //                     show: value,
    //                 };
    //             }
    //             return el;
    //         });
    //         newarticlesSorted = [{ articulos: newarticlesSorted, show: true }];
    //     } else {
    //         newarticlesSorted = articlesSorted.map((el) => {
    //             if (el.marca.codigo === element.codigo) {
    //                 return {
    //                     ...el,
    //                     show: value,
    //                 };
    //             }
    //             return el;
    //         });
    //     }

    //     this.setState({
    //         otrasMarcas: otrasMarcas.map((marca) => {
    //             if (element.codigo === marca.codigo)
    //                 return {
    //                     ...marca,
    //                     isChecked: value,
    //                 };
    //             return marca;
    //         }),
    //         articlesSorted: newarticlesSorted,
    //     });
    // }

    handleShopingCart(articulo) {
        let articuloSelected =
            articulo.ART_ID != null ? articulo.ART_ID : articulo.ART_CODIGO;
        this.setState({
            openArticuloCesta: true,
            articuloSelected,
            article: articulo,
        });
    }

    handleCheckDate(value, element) {
        const { filterDate } = this.state;
        this.setState({
            filterDate: filterDate.map((date) => {
                if (element.date === date.date)
                    return {
                        ...date,
                        check: value,
                    };
                return date;
            }),
        });
    }

    handleCheckAssembly(value, element) {
        const { filterAssembly } = this.state;
        this.setState({
            filterAssembly: filterAssembly.map((item) => {
                if (element.filter === item.filter)
                    return {
                        ...item,
                        check: value,
                    };
                return item;
            }),
        });
    }

    handleCheckBrand(value, element) {
        const { filterBrand } = this.state;
        this.setState({
            filterBrand: filterBrand.map((marca) => {
                if (element.filter === marca.filter)
                    return {
                        ...marca,
                        check: value,
                    };
                return marca;
            }),
        });
    }

    handleCheckBrandNotCross(value, element) {
        const { filterNotCrossBrand } = this.state;
        this.setState({
            filterNotCrossBrand: filterNotCrossBrand.map((marca) => {
                if (element.filter === marca.filter)
                    return {
                        ...marca,
                        check: value,
                    };
                return marca;
            }),
        });
    }

    handleCheckAllDate(value) {
        const { filterDate } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            checkFilter: {
                ...prevState.checkFilter,
                dates: value,
            },
            filterDate: filterDate.map((date) => {
                return {
                    ...date,
                    check: value,
                };
            }),
        }));
    }

    handleCheckAllAssembly(value) {
        const { filterAssembly } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            checkFilter: {
                ...prevState.checkFilter,
                assembly: value,
            },
            filterAssembly: filterAssembly.map((item) => {
                return {
                    ...item,
                    check: value,
                };
            }),
        }));
    }

    handleCheckAllBrand(value) {
        const { filterBrand } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            checkFilter: {
                ...prevState.checkFilter,
                brand: value,
            },
            filterBrand: filterBrand.map((group) => {
                return {
                    ...group,
                    check: value,
                };
            }),
        }));
    }

    handleCheckAllBrandNotCross(value) {
        const { filterNotCrossBrand } = this.state;
        this.setState((prevState) => ({
            ...prevState,
            checkFilter: {
                ...prevState.checkFilter,
                brandNotCross: value,
            },
            filterNotCrossBrand: filterNotCrossBrand.map((group) => {
                return {
                    ...group,
                    check: value,
                };
            }),
        }));
    }

    //-------------------------------------------------------------------------- SORT --------------------------------------------------------------------------
    //-- SORT AGRUPADO POR MARCA
    stockSort(isNewSearch) {
        const {
            rows: articulos,
            maxArticulos,
            totalProducts,
            filtros,
        } = this.state;
        if (!isNewSearch && !filtros.hideBrands) {
            this.renderStockSearched();
            return;
        }
        const newMaxPages = Math.ceil(totalProducts / maxArticulos);
        const marcasArticulos = toArray(
            groupBy(articulos, 'ART_ID_MARCA_ARTICULO')
        );
        let familiasArticulos = toArray(groupBy(articulos, 'CODIGO_FAMILIA'));
        familiasArticulos = familiasArticulos.map((el) => {
            return {
                FART_CODIGO: el[0].CODIGO_FAMILIA,
                FART_DESCRIPCION: el[0].DESCRIPCION_FAMILIA,
                isChecked: true,
            };
        });
        const ini = marcasArticulos.map((articulos) => {
            return {
                codigo: articulos[0].ART_ID_MARCA_ARTICULO,
                text: articulos[0].MART_DESCRIPCION,
                id: articulos[0].ART_ID_MARCA_ARTICULO,
                grupoMontaje: articulos[0].DESCRIPCION_FAMILIA,
                codigoMontaje: articulos[0].CODIGO_FAMILIA,
                isChecked: true,
                cruzado: false,
                maximoStock: 0,
            };
        });
        const sortArticulos = marcasArticulos.map((articulos, index) => ({
            articulos: articulos, //.sort((a, b) => sortArtByStock(a, b)),
            marca: {
                ...ini[index],
                cruzado:
                    articulos.filter((el) => el.CRUZADO === true).length > 0,
                maximoStock: maxBy(articulos, 'STOCK').STOCK,
            },
            show: true,
        }));
        //.sort((a, b) => sortByStock(a, b));

        const todasLasMarcas = sortArticulos.map((element) => element.marca);

        const marcasCruzadas = todasLasMarcas.filter((el) => el.cruzado);
        const otrasMarcas = todasLasMarcas.filter((el) => !el.cruzado);
        this.setState({
            articulos: sortArticulos,
            isFetching: false,
            maxPages: newMaxPages,
            marcasCruzadas,
            otrasMarcas,
            familiasArticulos,
            articlesSorted: sortArticulos,
        });
    }

    renderStockSearched() {
        const { rows, marcasCruzadas, otrasMarcas } = this.state;
        const marcasArticulos = toArray(groupBy(rows, 'ART_ID_MARCA_ARTICULO'));
        const aux = marcasArticulos.map((articluos) => {
            return {
                codigo: articluos[0].ART_ID_MARCA_ARTICULO,
                text: articluos[0].MART_DESCRIPCION,
                id: articluos[0].ART_ID_MARCA_ARTICULO,
                isChecked: true,
                cruzado: false,
                maximoStock: 0,
            };
        });

        const codCruzadas = marcasCruzadas
            .filter((element) => element.isChecked)
            .map((el) => el.codigo);
        const codNoCruzadas = otrasMarcas
            .filter((element) => element.isChecked)
            .map((el) => el.codigo);

        const sortArticulos = marcasArticulos.map((articulos, index) => {
            let articulo = articulos[0];
            let show = true;
            if (articulo) {
                if (
                    codCruzadas.includes(articulo.ART_ID_MARCA_ARTICULO) ||
                    codNoCruzadas.includes(articulo.ART_ID_MARCA_ARTICULO)
                ) {
                    show = true;
                } else {
                    show = false;
                }
            }
            return {
                articulos: articulos, //.sort((a, b) => sortArtByStock(a, b)),
                marca: {
                    ...aux[index],
                    cruzado:
                        articulos.filter((el) => el.Cruzado === true).length >
                        0,
                    maximoStock: maxBy(articulos, 'STOCK'), //.STOCK,
                },
                show,
            };
        });
        //.sort((a, b) => sortByStock(a, b));
        this.setState({
            articlesSorted: sortArticulos,
            isFetching: false,
        });
        return;
    }

    getFilters(filters) {
        return filters.map((filter) => ({
            filter: filter.Descripcion,
            codigo: filter.Codigo,
            check: true, //this.isChecked(filter.Codigo),
        }));
    }

    getFilterAssembly(filters) {
        const { grupoMontaje } = this.props;
        return filters.map((filter) => ({
            filter: filter.Descripcion,
            codigo: filter.Codigo,
            check: grupoMontaje
                .map((group) => group.codGrupo)
                .includes(filter.Codigo),
        }));
    }

    getFilterDate(filters) {
        const dates = filters.split(',');
        return dates.map((date) => ({
            date: date.trim(),
            check: true,
        }));
    }

    //--------------------------------------------------------- API CALL FUNCTIONS ---------------------------------------------------------
    getArticle() {
        const { codigo } = this.state;
        const { idMarcaArticulo } = this.props;
        if (codigo !== null && codigo !== '') {
            this.getArtByRef();
            return;
        }
        if (idMarcaArticulo !== null && idMarcaArticulo !== undefined) {
            this.getArtByMarca();
            return;
        }
        this.getArtByMoto();
        return;
    }

    getArtByMoto() {
        const { motoscat, esCliente, idMotor, grupoMontaje } = this.props;
        const {
            maxArticulos,
            currentPage,
            orderId,
            filterBrand,
            filterAssembly,
            filterNotCrossBrand,
            filterDate,
        } = this.state;
        this.setState({ isFetching: true });
        if (idMotor == null) {
            this.setState({ isFetching: false });
            return;
        }
        let cliente = motoscat.cliente;
        let centro = cliente ? cliente.CENTRO : null;
        const selectedBrand = Array.isArray(filterBrand)
            ? filterBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        const selectedBrandNotCross = Array.isArray(filterNotCrossBrand)
            ? filterNotCrossBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        const selectedDates = Array.isArray(filterDate)
            ? filterDate
                  .filter((date) => date.check)
                  .map((date) => date.date)
                  // .map((date) => '%' + date + '%')
                  .join(',')
            : [];
        const selectedAssemby =
            Array.isArray(filterAssembly) && filterAssembly.length > 0
                ? filterAssembly
                      .filter((filter) => filter.check)
                      .map((filter) => filter.codigo)
                      .join('|')
                : grupoMontaje.map((gm) => gm.codGrupo).join('|');

        smartFetch('/Articulos/GetArticulosPorMoto', {
            method: 'POST',
            body: {
                IdMoto: idMotor,
                // GrupoMontaje: grupoMontaje.codigo,
                esCliente: esCliente,
                Cliente: cliente ? cliente.CODIGO : null,
                Centro: centro ? centro.CODIGO : null,
                Almacen: cliente ? cliente.ALMACEN_PRE : null,
                FechasMontaje: selectedDates,
                Page: currentPage,
                PageLength: maxArticulos,
                Indice: orderId,
                TBL_MARCAS: selectedBrand,
                TBL_MARCAS_NOT_CROSS: selectedBrandNotCross,
                TBL_GRUPOS_MONTAJE: selectedAssemby,
            },
        })
            .then(({ body }) => {
                if (body.Ok) {
                    const articulos = body.Articulos.Articles
                        // .filter(
                        //     (art) =>
                        //         motoscat.grupoMontaje.codigo === art.CODIGO_FAMILIA
                        // )
                        .map((el) => {
                            return { ...el, show: true };
                        });
                    const filters = body.Articulos.Filters;
                    const gruposMarca =
                        filterBrand.length > 0
                            ? filterBrand
                            : this.getFilters(filters.FilterMarcas);
                    const gruposMarcaNotCross = this.getFilters(
                        filters.FilterNotCrossMarcas
                    );
                    const gruposFechasMontaje =
                        filterDate.length > 0
                            ? filterDate
                            : this.getFilterDate(
                                  filters.FilterFechasGrupoMontaje
                              );
                    const gruposMontaje =
                        filterAssembly.length > 0
                            ? filterAssembly
                            : this.getFilterAssembly(
                                  filters.FilterGrupoMontaje
                              );
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            rows: articulos,
                            ini: articulos,
                            idMotor: idMotor,
                            orderId: orderId,
                            totalProducts: filters.TotalArticles,
                            filterBrand: gruposMarca,
                            filterNotCrossBrand: gruposMarcaNotCross,
                            filterDate: gruposFechasMontaje,
                            filterAssembly: gruposMontaje,
                        }),
                        () => {
                            this.addMoto();
                            this.stockSort(true);
                        }
                    );
                    return;
                }
                this.handleErrorSearch(body.MsgError);
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    getArtByRef() {
        const { motoscat } = this.props;
        const {
            codigo,
            maxArticulos,
            currentPage,
            orderId,
            filterNotCrossBrand,
            filterBrand,
        } = this.state;
        if (codigo === '' || codigo == null) {
            if (motoscat && motoscat.idMotor) {
                this.getArtByMoto();
                return;
            }

            this.setState({ isFetching: false }, () =>
                swalMsg('error', translate('introduzca_referencia'))
            );
            return;
        }
        let cliente = motoscat.cliente;
        let centro = cliente != null ? cliente.CENTRO : null;
        const selectedBrand = Array.isArray(filterBrand)
            ? filterBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        const selectedBrandNotCross = Array.isArray(filterNotCrossBrand)
            ? filterNotCrossBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        smartFetch('/Articulos/GetArticulosPorReferencia', {
            method: 'POST',
            body: {
                ArtCodigo: codigo,
                Cliente: cliente ? cliente.CODIGO : null,
                Centro: centro ? centro.CODIGO : null,
                Almacen: cliente ? cliente.ALMACEN_PRE : null,
                Indice: orderId,
                Page: currentPage,
                PageLength: maxArticulos,
                Equivalencia: motoscat ? motoscat.stateEquiv : true,
                TBL_MARCAS: selectedBrand,
                TBL_MARCAS_NOT_CROSS: selectedBrandNotCross,
            },
        })
            .then((res) => {
                let body = res.body;
                if (body.Ok) {
                    const articulos = body.Articulos.Articles.map((el) => {
                        return { ...el, show: true };
                    });
                    const filters = body.Articulos.Filters;
                    const gruposMarca =
                        filterBrand.length > 0
                            ? filterBrand
                            : this.getFilters(filters.FilterMarcas);
                    const gruposMarcaNotCross =
                        filterNotCrossBrand.length > 0
                            ? filterNotCrossBrand
                            : this.getFilters(filters.FilterNotCrossMarcas);
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            rows: articulos,
                            ini: articulos,
                            orderId: orderId,
                            totalProducts: filters.TotalArticles,
                            filterBrand: gruposMarca,
                            filterNotCrossBrand: gruposMarcaNotCross,
                        }),
                        () => {
                            this.setReferencia(this.state.codigo);
                            this.stockSort(true);
                        }
                    );
                    return;
                }
                this.handleErrorSearch(body.MsgError);
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    getArtByMarca() {
        const { motoscat, idMarcaArticulo } = this.props;
        const {
            maxArticulos,
            currentPage,
            orderId,
            filterBrand,
            filterNotCrossBrand,
        } = this.state;
        if (idMarcaArticulo === null) {
            this.setState({ isFetching: false });
            return;
        }
        const cliente = motoscat.cliente;
        const selectedBrand = Array.isArray(filterBrand)
            ? filterBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        const selectedBrandNotCross = Array.isArray(filterNotCrossBrand)
            ? filterNotCrossBrand
                  .filter((group) => !group.check)
                  .map((group) => group.codigo)
                  .join('|')
            : [];
        smartFetch('/Articulos/GetArticulosPorMarca', {
            method: 'POST',
            body: {
                IdMarca: idMarcaArticulo,
                Cliente: cliente ? cliente.CODIGO : null,
                Almacen: cliente ? cliente.ALMACEN_PRE : null,
                Page: currentPage,
                PageLength: maxArticulos,
                Indice: orderId,
                TBL_MARCAS: selectedBrand,
                TBL_MARCAS_NOT_CROSS: selectedBrandNotCross,
            },
        })
            .then((res) => {
                const body = res.body;
                if (body.Ok) {
                    const articulos = body.Articulos.Articles.map((el) => {
                        return { ...el, show: true };
                    });

                    const filters = body.Articulos.Filters;
                    const gruposMarca =
                        filterBrand.length > 0
                            ? filterBrand
                            : this.getFilters(filters.FilterMarcas);
                    const gruposMarcaNotCross =
                        filterNotCrossBrand.length > 0
                            ? filterNotCrossBrand
                            : this.getFilters(filters.FilterNotCrossMarcas);
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            rows: articulos,
                            ini: articulos,
                            orderId: orderId,
                            totalProducts: filters.TotalArticles,
                            filterBrand: gruposMarca,
                            filterNotCrossBrand: gruposMarcaNotCross,
                        }),
                        () => {
                            this.stockSort(true);
                        }
                    );
                    return;
                }
                this.handleErrorSearch(body.MsgError);
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    getArtByOEM(codigoOEM, marcaOEM) {
        const { motoscat } = this.props;
        const { maxArticulos, currentPage, orderId } = this.state;
        this.setState({ isFetching: true });
        let cliente = motoscat.cliente;

        smartFetch('/Articulos/GetArticulosPorOEM', {
            method: 'POST',
            body: {
                CodigoOEM: codigoOEM,
                MarcaOEM: marcaOEM,
                Cliente: cliente ? cliente.CODIGO : null,
                Almacen: cliente ? cliente.ALMACEN_PRE : null,
                Page: currentPage,
                PageLength: maxArticulos,
                Indice: orderId,
            },
        })
            .then((res) => {
                const body = res.body;
                if (body.Ok) {
                    const articulos = body.Articulos.Articles.map((el) => {
                        return { ...el, show: true };
                    });

                    const filters = body.Articulos.Filters;
                    this.setState(
                        (prevState) => ({
                            ...prevState,
                            rows: articulos,
                            ini: articulos,
                            orderId: orderId,
                            totalProducts: filters.TotalArticles,
                        }),
                        () => {
                            this.props.setReferencia('');
                            //TODO this.props.setMotor(null,null);
                            this.stockSort(true);
                        }
                    );
                    return;
                }
                this.handleErrorSearch(body.MsgError);
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    //Cesta
    addArticuloCesta(reg) {
        if (reg == null || (Array.isArray(reg) && reg.length === 0)) {
            this.setState({ openArticuloCesta: false });
            return;
        }
        smartFetch(GRIDS.CESTA.controller + '/ActualizarLineasCesta', {
            method: 'POST',
            body: {
                Lineas: reg,
            },
        })
            .then((res) => {
                let body = res.body;
                if (body.Ok) {
                    this.setState({ openArticuloCesta: false }, () => {
                        this.getNumeroLineas();
                        windowsAlert('Artículo añadido a la cesta');
                    });
                    return;
                }
                this.setState({ openArticuloCesta: false }, () =>
                    swalMsg('error', body.MsgError)
                );
            })
            .catch((ex) => this.setState({ openArticuloCesta: false }));
    }

    getNumeroLineas() {
        smartFetch(GRIDS.CESTA.controller + '/GetNumeroLineas', {
            method: 'POST',
        })
            .then((res) => {
                if (res.body.Ok) {
                    this.props.changeLineasCesta(res.body.NumeroLineas);
                    return;
                }
                swalMsg('error', res.body.MsgError);
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    //Historial
    setReferencia() {
        const { codigo } = this.state;
        if (codigo === '' || codigo == null) return;
        let accion = ACCIONES_ROW.INSERT;
        smartFetch('/Historico/ActualizarRegistro', {
            method: 'PUT',
            body: {
                Accion: accion,
                Reg: {
                    HIS_ID_TIPO: HISTORICO_MOTOSCAT.REFERENCIA,
                    HIS_REFERENCIA_ART: codigo,
                },
            },
        })
            .then((res) => {
                let body = res.body;
                if (!body.ok) {
                    swalMsg('error', body.mensajeError);
                    return;
                }
            })
            .catch((ex) => this.setState({ isFetching: false }));
        this.setState({ openMotos: false });
    }

    //Historial
    addMoto() {
        const { motoscat } = this.props;
        smartFetch('/Historico/ActualizarRegistro', {
            method: 'PUT',
            body: {
                Accion: 0,
                Reg: {
                    HIS_ID: null,
                    HIS_ID_TIPO: HISTORICO_MOTOSCAT.MOTOS,
                    HIS_ID_MARCA_VEH: motoscat.idMarca,
                    HIS_ID_MODELO_VEH: motoscat.idModelo,
                    HIS_ID_MOTOR_VEH: motoscat.idMotor,
                    HIS_MARCA_VEH: motoscat.marca,
                    HIS_MODELO_VEH: motoscat.modelo,
                    HIS_MOTOR_VEH: motoscat.motor,
                    HIS_CC_VEH: motoscat.cc,
                    HIS_YEAR: motoscat.anyo,
                },
            },
        })
            .then((res) => {
                let body = res.body;
                if (!body.ok) {
                    swalMsg('error', body.mensajeError);

                    return;
                }
            })
            .catch((ex) => this.setState({ isFetching: false }));
    }

    //-------------------------------------------------------------------------------------- MAQUETACION --------------------------------------------------------------------------------------

    renderFilterDate(classObj, filters) {
        const { checkFilter } = this.state;
        return (
            <div className={cls('filtros-acordeon-wrapper', classObj)}>
                <div className='marcas-wrapper font-weight-bold'>
                    {Array.isArray(filters) && filters.length > 0 && (
                        <Fragment>
                            <div className='pb-2 checkbox-label'>
                                <CheckboxSKR
                                    key={translate('fecha_motanje')}
                                    type={TEXTBOX.CHECKBOX}
                                    label={translate('fecha_motanje')}
                                    isChecked={checkFilter.dates}
                                    handleClick={(value) => {
                                        this.handleCheckAllDate(value);
                                    }}
                                    className='mb-2'
                                />
                            </div>
                            {filters.map((element, index) => {
                                return (
                                    <CheckboxSKR
                                        key={index}
                                        type={TEXTBOX.CHECKBOX}
                                        label={element.date}
                                        isChecked={element.check}
                                        handleClick={(value) => {
                                            this.handleCheckDate(
                                                value,
                                                element
                                            );
                                        }}
                                        className='mb-2'
                                    />
                                );
                            })}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }

    renderFilterBrand(classObj, filters) {
        const { checkFilter } = this.state;
        return (
            <div className={cls('filtros-acordeon-wrapper', classObj)}>
                <div className='marcas-wrapper font-weight-bold'>
                    {Array.isArray(filters) && filters.length > 0 && (
                        <Fragment>
                            <div className='pb-2 checkbox-label'>
                                <CheckboxSKR
                                    key={translate('marcas')}
                                    type={TEXTBOX.CHECKBOX}
                                    label={translate('marcas')}
                                    isChecked={checkFilter.brand}
                                    handleClick={(value) => {
                                        this.handleCheckAllBrand(value);
                                    }}
                                    className='mb-2'
                                />
                            </div>
                            {filters.map((element, index) => {
                                return (
                                    <CheckboxSKR
                                        key={index}
                                        type={TEXTBOX.CHECKBOX}
                                        label={element.filter}
                                        isChecked={element.check}
                                        handleClick={(value) => {
                                            this.handleCheckBrand(
                                                value,
                                                element
                                            );
                                        }}
                                        className='mb-2'
                                    />
                                );
                            })}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }

    renderFilterBrandNotCross(classObj, filters) {
        const { checkFilter } = this.state;
        return (
            <div className={cls('filtros-acordeon-wrapper', classObj)}>
                <div className='marcas-wrapper font-weight-bold'>
                    {Array.isArray(filters) && filters.length > 0 && (
                        <Fragment>
                            <div className='pb-2 checkbox-label'>
                                <CheckboxSKR
                                    key={translate('marcas')}
                                    type={TEXTBOX.CHECKBOX}
                                    label={translate('marcas')}
                                    isChecked={checkFilter.brandNotCross}
                                    handleClick={(value) => {
                                        this.handleCheckAllBrandNotCross(value);
                                    }}
                                    className='mb-2'
                                />
                            </div>
                            {filters.map((element, index) => {
                                return (
                                    <CheckboxSKR
                                        key={index}
                                        type={TEXTBOX.CHECKBOX}
                                        label={element.filter}
                                        isChecked={element.check}
                                        handleClick={(value) => {
                                            this.handleCheckBrandNotCross(
                                                value,
                                                element
                                            );
                                        }}
                                        className='mb-2'
                                    />
                                );
                            })}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }

    renderFilterAssemblyGroup(classObj, filters) {
        const { checkFilter } = this.state;
        return (
            <div className={cls('filtros-acordeon-wrapper', classObj)}>
                <div
                    className='marcas-wrapper font-weight-bold'
                    style={{ width: 'fit-content' }}
                >
                    {Array.isArray(filters) && filters.length > 0 && (
                        <Fragment>
                            <div className='pb-2 checkbox-label'>
                                <CheckboxSKR
                                    key={translate('grupo_montaje')}
                                    type={TEXTBOX.CHECKBOX}
                                    label={translate('grupo_montaje')}
                                    isChecked={checkFilter.assembly}
                                    handleClick={(value) => {
                                        this.handleCheckAllAssembly(value);
                                    }}
                                    className='mb-2'
                                />
                            </div>
                            {filters.map((element, index) => {
                                return (
                                    <CheckboxSKR
                                        key={index}
                                        type={TEXTBOX.CHECKBOX}
                                        label={element.filter}
                                        isChecked={element.check}
                                        handleClick={(value) => {
                                            this.handleCheckAssembly(
                                                value,
                                                element
                                            );
                                        }}
                                        className='mb-2'
                                    />
                                );
                            })}
                        </Fragment>
                    )}
                </div>
            </div>
        );
    }

    renderFilters() {
        const {
            filtros,
            filterBrand,
            filterNotCrossBrand,
            filterDate,
            filterAssembly,
            acordeonMarcas,
            acordeonGruposMontaje,
            acordeonMarcasNotCross,
            acordeonFechasMontaje,
            ordenar,
            orderId,
        } = this.state;
        const classCheckMarcas = {
            active: acordeonMarcas,
            closed: !acordeonMarcas,
        };
        const classCheckMarcasNotCross = {
            active: acordeonMarcasNotCross,
            closed: !acordeonMarcasNotCross,
        };
        const classCheckFechasMontaje = {
            active: acordeonFechasMontaje,
            closed: !acordeonFechasMontaje,
        };
        const classCheckGruposMontaje = {
            active: acordeonGruposMontaje,
            closed: !acordeonGruposMontaje,
        };
        return (
            <div className='left-filters'>
                {/* BOTONES 1-NO TITULO ART, 2-RESUMEN ART Y 3-VER SOLO PVP O STOCK  */}
                <div className='select-buttons mb-3'>
                    <ActionBarButton
                        icon
                        iconCls={cls({
                            'ms-Icon ms-Icon--Bookmarks': !filtros.hideBrands,
                            'ms-Icon ms-Icon--BulletedList': filtros.hideBrands,
                        })}
                        class='btn btn-icon-scuare mr-1'
                        onClick={() => this.handleRemoveMarcas()}
                    />
                    <ActionBarButton
                        icon
                        iconCls={cls({
                            'ms-Icon ms-Icon--BackToWindow':
                                !filtros.compactArticle,
                            'ms-Icon ms-Icon--FullScreen':
                                filtros.compactArticle,
                        })}
                        class='btn btn-icon-scuare mr-1'
                        onClick={() =>
                            this.setState({
                                filtros: {
                                    ...filtros,
                                    compactArticle: !filtros.compactArticle,
                                },
                            })
                        }
                    />
                    <ActionBarButton
                        icon
                        iconCls={cls({
                            'ms-Icon ms-Icon--View': !filtros.showLessPrice,
                            'ms-Icon ms-Icon--Hide3': filtros.showLessPrice,
                        })}
                        class='btn btn-icon-scuare mr-1'
                        onClick={() =>
                            this.setState({
                                filtros: {
                                    ...filtros,
                                    showLessPrice: !filtros.showLessPrice,
                                },
                            })
                        }
                    />
                </div>

                {/* ORDENAR POR... */}
                <div className='select-wrapper'>
                    <div className='input-group dd-filter'>
                        <SelectSKR
                            placeholder='Ordenar por'
                            options={ordenar}
                            value={orderId}
                            onChange={(value) => this.handleSort(value)}
                        />
                    </div>
                </div>

                {/* CÓDIGO ARTÍCULO */}
                {/* <div className='searchbar-box mb-2'>
                    <div className='search-bar-articles'>
                        <div className='inner-form'>
                            <div className='input-field first-wrap'>
                                <Input
                                    type={INPUTS.TEXT}
                                    placeholder={translate('codigo')}
                                    value={this.state.codigo}
                                    onChange={(value) => {
                                        this.setState({
                                            codigo: value,
                                        });
                                    }}
                                    onEnter={this.handleKeyDown}
                                />
                            </div>
                            <div className='input-field third-wrap'>
                                <button
                                    className='btn-search'
                                    type='button'
                                    onClick={() =>
                                        this.setState(
                                            {
                                                isFetching: true,
                                                marcasCruzadas: [],
                                                familiasArticulos: [],
                                                otrasMarcas: [],
                                                check: {
                                                    cruzadas: true,
                                                    otras: true,
                                                },
                                            },
                                            () => this.getArtByRef()
                                        )
                                    }
                                >
                                    <i className='ms-Icon ms-Icon--Zoom icon-search' />
                                </button>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* FILTRAR RESULTADO */}
                <Button
                    label='Filtrar articulos'
                    className='pt-3'
                    onClick={() => {
                        this.setState({ isFetching: true, currentPage: 1 });
                        this.getArticle();
                    }}
                />
                <div className='scroll-box pt-3'>
                    {/* FILTRAR POR GRUPO DE MONTAJE */}
                    {Array.isArray(filterAssembly) &&
                        filterAssembly.length > 0 && (
                            <Fragment>
                                <div
                                    className={cls(
                                        'filtros-acordeon',
                                        classCheckGruposMontaje
                                    )}
                                    onClick={() =>
                                        this.setState({
                                            acordeonGruposMontaje:
                                                !acordeonGruposMontaje,
                                        })
                                    }
                                >
                                    <div className='d-flex justify-content-between'>
                                        <span>
                                            {translate('_grupos_montaje')}
                                        </span>
                                        <i
                                            className={cls('', {
                                                'ms-Icon ms-Icon--DoubleChevronDown':
                                                    acordeonGruposMontaje,
                                                'ms-Icon ms-Icon--DoubleChevronUp':
                                                    !acordeonGruposMontaje,
                                            })}
                                        />
                                    </div>
                                </div>
                                {this.renderFilterAssemblyGroup(
                                    classCheckGruposMontaje,
                                    filterAssembly
                                )}
                            </Fragment>
                        )}

                    {/* FILTRAR POR FECHAS DE MONTAJE */}
                    {Array.isArray(filterDate) && filterDate.length > 0 && (
                        <Fragment>
                            <div
                                className={cls(
                                    'filtros-acordeon',
                                    classCheckFechasMontaje
                                )}
                                onClick={() =>
                                    this.setState({
                                        acordeonFechasMontaje:
                                            !acordeonFechasMontaje,
                                    })
                                }
                            >
                                <div className='d-flex justify-content-between'>
                                    <span>{translate('_fechas_montaje')}</span>
                                    <i
                                        className={cls('', {
                                            'ms-Icon ms-Icon--DoubleChevronDown':
                                                acordeonFechasMontaje,
                                            'ms-Icon ms-Icon--DoubleChevronUp':
                                                !acordeonFechasMontaje,
                                        })}
                                    />
                                </div>
                            </div>
                            {this.renderFilterDate(
                                classCheckFechasMontaje,
                                filterDate
                            )}
                        </Fragment>
                    )}

                    {/* FILTRAR POR MARCAS */}
                    {Array.isArray(filterBrand) && filterBrand.length > 0 && (
                        <Fragment>
                            <div
                                className={cls(
                                    'filtros-acordeon',
                                    classCheckMarcas
                                )}
                                onClick={() =>
                                    this.setState({
                                        acordeonMarcas: !acordeonMarcas,
                                    })
                                }
                            >
                                <div className='d-flex justify-content-between'>
                                    <span>{translate('_marcas')}</span>
                                    <i
                                        className={cls('', {
                                            'ms-Icon ms-Icon--DoubleChevronDown':
                                                acordeonMarcas,
                                            'ms-Icon ms-Icon--DoubleChevronUp':
                                                !acordeonMarcas,
                                        })}
                                    />
                                </div>
                            </div>
                            {this.renderFilterBrand(
                                classCheckMarcas,
                                filterBrand
                            )}
                        </Fragment>
                    )}

                    {/* FILTRAR POR MARCAS ARTICULOS NO CRUZADOS*/}
                    {Array.isArray(filterNotCrossBrand) &&
                        filterNotCrossBrand.length > 0 && (
                            <Fragment>
                                <div
                                    className={cls(
                                        'filtros-acordeon',
                                        classCheckMarcasNotCross
                                    )}
                                    onClick={() =>
                                        this.setState({
                                            acordeonMarcasNotCross:
                                                !acordeonMarcasNotCross,
                                        })
                                    }
                                >
                                    <div className='d-flex justify-content-between'>
                                        <span>
                                            {translate('_marcasNotCross')}
                                        </span>
                                        <i
                                            className={cls('', {
                                                'ms-Icon ms-Icon--DoubleChevronDown':
                                                    acordeonMarcasNotCross,
                                                'ms-Icon ms-Icon--DoubleChevronUp':
                                                    !acordeonMarcasNotCross,
                                            })}
                                        />
                                    </div>
                                </div>
                                {this.renderFilterBrandNotCross(
                                    classCheckMarcasNotCross,
                                    filterNotCrossBrand
                                )}
                            </Fragment>
                        )}
                </div>
            </div>
        );
    }

    //Articulo Completo (No comapctado)
    renderArticleContent(articulo, artPropiedad) {
        const { filtros, orderId } = this.state;
        const { motoscat } = this.props;
        return (
            <Fragment>
                <div className='articulo-desc'>
                    <div className='desc-left'>
                        <div>
                            <div className='header-content'>
                                <div className='label'>
                                    {(filtros.hideBrands ||
                                        filtroSinMarca.includes(orderId)) && (
                                        <span className='nombre-marca'>
                                            {articulo.MART_DESCRIPCION}&nbsp;
                                        </span>
                                    )}
                                    {/* <span>{articulo.ART_CODIGO} </span> */}
                                </div>
                                {articulo.ART_CODIGO != null && (
                                    <div>
                                        <span>
                                            {translate('referencia_proveedor') +
                                                ':'}
                                            &nbsp;
                                            {articulo.ART_CODIGO}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className='header-content'>
                                <span className='label'>
                                    {articulo.DESCRIPCION}
                                </span>
                            </div>
                            {articulo.ART_PROPIEDAD !== null && (
                                <div className='header-content d-flex flex-column'>
                                    {artPropiedad.map((art, index) => {
                                        return (
                                            <span key={index} className='label'>
                                                {art}
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                            {articulo.ART_FECHA_MONTAJE !== null &&
                                articulo.ART_FECHA_MONTAJE && (
                                    <div className='header-content'>
                                        <span className='label'>
                                            {`Años Montaje: Desde ${
                                                articulo.ART_FECHA_MONTAJE.split(
                                                    ','
                                                )[0]
                                            } al ${
                                                articulo.ART_FECHA_MONTAJE.split(
                                                    ','
                                                )[
                                                    articulo.ART_FECHA_MONTAJE.split(
                                                        ','
                                                    ).length - 1
                                                ]
                                            }`}
                                        </span>
                                    </div>
                                )}
                            {articulo.ART_OEM !== null && (
                                <div className='header-content'>
                                    <Button
                                        label='Articulos OEM'
                                        onClick={() =>
                                            this.setState({
                                                fichaOEM: {
                                                    open: true,
                                                    reg: articulo.ART_OEM,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            )}
                            {articulo.ART_EQUV !== null && (
                                <div className='header-content pt-2'>
                                    <Button
                                        label='Articulos Equivalente'
                                        onClick={() =>
                                            this.setState({
                                                fichaEqv: {
                                                    open: true,
                                                    reg: articulo.ART_EQUV,
                                                },
                                            })
                                        }
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div
                        className={cls('desc-right', {
                            invisible: !articulo.CRUZADO,
                        })}
                    >
                        <div className={'stock'}>
                            <div>{translate('stock')} </div>
                            <div
                                className={cls('article-buttons-container', {
                                    invisible: !articulo.CRUZADO,
                                })}
                            >
                                <ActionBarButton
                                    icon
                                    iconCls='ms-Icon ms-Icon--POISolid mr-'
                                    class={cls('btn-rounded semaforo', {
                                        verde: articulo.STOCK_ALMACEN > 0,
                                        ambar:
                                            articulo.STOCK_ALMACEN <= 0 &&
                                            articulo.STOCK > 0,
                                        rojo:
                                            articulo.STOCK_ALMACEN <= 0 &&
                                            articulo.STOCK <= 0,
                                    })}
                                    onClick={() => {
                                        this.setState({
                                            fichaStock: {
                                                open: true,
                                                reg: articulo.ART_CODIGO,
                                            },
                                        });
                                    }}
                                />
                                <div>
                                    <span className='stock-almacen'>
                                        {articulo.STOCK_ALMACEN}&nbsp;
                                    </span>
                                    <span className='stock-total'>
                                        /&nbsp;{articulo.STOCK}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className='articulo-pvp'>
                            <div>{translate('pvp')} </div>
                            <div>
                                {articulo.PVP_RECOMENDADO === 0
                                    ? formatCurrency(articulo.PVP)
                                    : formatCurrency(articulo.PVP_RECOMENDADO)}
                            </div>
                        </div>

                        {!filtros.showLessPrice && (
                            <Fragment>
                                <div className='articulo-precio'>
                                    <div>{translate('precio')} </div>
                                    <div>{formatCurrency(articulo.PVP)}</div>
                                </div>
                                <div className='articulo-dto'>
                                    <div>{translate('dto')} </div>
                                    <div>
                                        {formatCurrency(articulo.DTO, 2, '%')}
                                    </div>
                                </div>
                                <div className='articulo-neto'>
                                    <div>{translate('neto')} </div>
                                    <div>{formatCurrency(articulo.NETO)}</div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className='d-flex align-items-center'>
                        {motoscat &&
                            motoscat.cliente &&
                            motoscat.cliente.CODIGO && (
                                <button
                                    className='btn btn-action btn-rounded semaforo verde mb-0'
                                    onClick={() =>
                                        this.handleShopingCart(articulo)
                                    }
                                >
                                    <i className='ms-Icon ms-Icon--ShoppingCart ' />
                                </button>
                            )}
                    </div>
                </div>
            </Fragment>
        );
    }

    //Articulo Completo Comapctado
    renderArticleCompactContent(articulo) {
        const { filtros } = this.state;
        const { motoscat } = this.props;
        return (
            <Fragment>
                <div className='articulo-desc'>
                    <div className='desc-left'>
                        <div
                            className={cls('article-buttons-container mr-3', {
                                invisible: !articulo.CRUZADO,
                            })}
                        >
                            <ActionBarButton
                                icon
                                iconCls='ms-Icon ms-Icon--POISolid'
                                class={cls('btn-rounded semaforo', {
                                    verde: articulo.STOCK_ALMACEN > 0,
                                    ambar:
                                        articulo.STOCK_ALMACEN <= 0 &&
                                        articulo.STOCK > 0,
                                    rojo:
                                        articulo.STOCK_ALMACEN <= 0 &&
                                        articulo.STOCK <= 0,
                                })}
                                onClick={() => {
                                    this.setState({
                                        fichaStock: {
                                            open: true,
                                            reg: articulo.ART_CODIGO,
                                        },
                                    });
                                }}
                            />
                        </div>
                        <div>
                            <div className='header-content'>
                                <span className='label'>
                                    {filtros.hideBrands && (
                                        <Fragment>
                                            {articulo.MART_DESCRIPCION}
                                            {': '}
                                        </Fragment>
                                    )}
                                    &nbsp;
                                    {translate('referencia_proveedor') + ':'}
                                    &nbsp;
                                    {/* {articulo.ARTICULO} */}
                                    {articulo.ART_CODIGO}
                                </span>
                            </div>
                            <div className='header-content'>
                                {/* <button className='btn btn-transparent px-0'>
                                    <i className='ms-Icon ms-Icon--InfoSolid' />
                                    <span>{translate('mas_info')}</span>
                                </button> */}
                            </div>
                        </div>
                    </div>
                    <div
                        className={cls('desc-right', {
                            invisible: !articulo.CRUZADO,
                        })}
                    >
                        <div
                            className={cls('stock', {
                                'd-none': this.props.esCliente,
                            })}
                        >
                            <div>{translate('stock')} </div>
                            <div>
                                <span className='stock-almacen'>
                                    {articulo.STOCK_ALMACEN}
                                </span>
                                <span className='stock-total'>
                                    /{articulo.STOCK}
                                </span>
                            </div>
                        </div>

                        <div className='articulo-pvp'>
                            <div>{translate('pvp')} </div>
                            <div>
                                {articulo.PVP_RECOMENDADO === 0
                                    ? formatCurrency(articulo.PVP)
                                    : formatCurrency(articulo.PVP_RECOMENDADO)}
                            </div>
                        </div>

                        {!filtros.showLessPrice && (
                            <Fragment>
                                <div className='articulo-precio'>
                                    <div>{translate('precio')} </div>
                                    <div>{formatCurrency(articulo.PVP)}</div>
                                </div>
                                <div className='articulo-dto'>
                                    <div>{translate('dto')} </div>
                                    <div>
                                        {formatCurrency(articulo.DTO, 2, '%')}
                                    </div>
                                </div>
                                <div className='articulo-neto'>
                                    <div>{translate('neto')} </div>
                                    <div>{formatCurrency(articulo.NETO)}</div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className='d-flex align-items-center'>
                        {motoscat &&
                            motoscat.cliente &&
                            motoscat.cliente.CODIGO && (
                                <button
                                    className='btn btn-action btn-rounded semaforo verde mb-0'
                                    onClick={() =>
                                        this.handleShopingCart(articulo)
                                    }
                                >
                                    <i className='ms-Icon ms-Icon--ShoppingCart ' />
                                </button>
                            )}
                    </div>
                </div>
            </Fragment>
        );
    }

    renderArticle() {
        const { articlesSorted, filtros } = this.state;
        return articlesSorted.map((element, indexMarca) => {
            if (element.show)
                return (
                    <Fragment key={indexMarca}>
                        {!filtros.hideBrands && element.marca && (
                            <div className='marca-articulo col-12 m-0 mt-4'>
                                <span>{element.marca.text}</span>
                            </div>
                        )}
                        {element.articulos.map((articulo, indexArticulo) => {
                            if (articulo.show === false) return null;
                            const artPropiedad =
                                (articulo.ART_PROPIEDAD !== null &&
                                    articulo.ART_PROPIEDAD.split(',')) ||
                                [];
                            return (
                                <div
                                    key={indexArticulo}
                                    className='articulo col-12'
                                >
                                    <div
                                        className='article-left'
                                        onClick={
                                            articulo.TIENE_IMAGEN
                                                ? this.handleImage(
                                                      articulo.ART_CODIGO
                                                  )
                                                : ''
                                        }
                                    >
                                        {this.renderImage(articulo)}
                                    </div>
                                    <div className='article-right'>
                                        <div className='article-content-wrapper'>
                                            {this.renderArticleContent(
                                                articulo,
                                                artPropiedad
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Fragment>
                );
        });
    }

    renderArticleCompacted() {
        const { articlesSorted, filtros } = this.state;
        return articlesSorted.map((element, indexMarca) => {
            if (element.show)
                return (
                    <Fragment key={indexMarca}>
                        {!filtros.hideBrands && element.marca && (
                            <div className='marca-articulo col-12 mt-4'>
                                <span>{element.marca.text}</span>
                            </div>
                        )}
                        {element.articulos.map((articulo, indexArticulo) => {
                            if (articulo.show === false) return null;
                            return (
                                <div
                                    key={indexArticulo}
                                    className='articulo col-12'
                                >
                                    <div className='article-right pl-0'>
                                        <div className='article-content-wrapper'>
                                            {this.renderArticleCompactContent(
                                                articulo
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Fragment>
                );
        });
    }

    renderImage(articulo) {
        return articulo.TIENE_IMAGEN ? (
            <img
                loading='lazy'
                alt={articulo.ART_CODIGO}
                src={`${SERVER}/Articulos/GetImagenERP/${articulo.ART_CODIGO}/0/1/0/0`}
                className='img-fluid'
                default='/Styles/img/default-img.svg'
            />
        ) : (
            <img className='img-fluid' src={'/Styles/img/default-img.svg'} />
        );
    }

    renderContent() {
        const {
            isFetching,
            articlesSorted,
            filtros,
            currentPage,
            totalProducts,
            maxArticulos,
        } = this.state;
        if (isFetching)
            return <Spinner label={translate('buscando_articulos')} />;
        if (
            articlesSorted === null ||
            (Array.isArray(articlesSorted) && articlesSorted.length === 0)
        ) {
            return (
                <div className='content'>
                    <div>{translate('seleccione_moto_o_referencia')}</div>
                </div>
            );
        }
        return (
            <div className='content mt-0'>
                <div className='row m-0' style={{ width: '100%' }}>
                    {filtros.compactArticle
                        ? this.renderArticleCompacted()
                        : this.renderArticle()}
                </div>
                {totalProducts > maxArticulos && (
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={totalProducts}
                        itemsCountPerPage={maxArticulos}
                        pageRangeDisplayed={5}
                        onChange={this.handleChangePage}
                        itemClass='page-item'
                        linkClass='page-link'
                        innerClass='pagination !important'
                    />
                )}
            </div>
        );
    }

    renderBody() {
        return (
            <Fragment>
                {this.renderFilters()}
                {this.renderContent()}
            </Fragment>
        );
    }

    //-------------------------------------------------------------------------------------- Drawers --------------------------------------------------------------------------------------

    renderArticuloCesta() {
        const { openArticuloCesta, article, articuloSelected } = this.state;
        return (
            <Drawer
                open={openArticuloCesta}
                position='right'
                width='600px'
                onClose={() => this.setState({ openArticuloCesta: false })}
            >
                <AnyadirArticulo
                    articleId={articuloSelected}
                    accept={(reg) => this.addArticuloCesta(reg)}
                    reg={article}
                    cancel={() =>
                        this.setState({
                            openArticuloCesta: false,
                            article: null,
                        })
                    }
                />
            </Drawer>
        );
    }

    renderStocks() {
        const { fichaStock } = this.state;
        return (
            <Ficha
                ficha={FICHAS.STOCK_ALMACENES}
                width={'500px'}
                open={fichaStock.open}
                estado={ESTADOS_FORM.CONSULTA}
                reg={fichaStock.reg}
                cancel={() =>
                    this.setState({
                        fichaStock: {
                            open: false,
                            reg: null,
                        },
                    })
                }
            />
        );
    }

    renderOEM() {
        const { fichaOEM } = this.state;
        return (
            <Ficha
                ficha={FICHAS.ARTICULOS_OEM}
                width={'500px'}
                open={fichaOEM.open}
                estado={ESTADOS_FORM.EDICION}
                reg={fichaOEM.reg}
                cancel={() =>
                    this.setState({
                        fichaOEM: {
                            open: false,
                            reg: null,
                        },
                    })
                }
            />
        );
    }

    renderEquiv() {
        const { fichaEqv } = this.state;
        return (
            <Ficha
                ficha={FICHAS.ARTICULOS_EQUIV}
                width={'500px'}
                open={fichaEqv.open}
                estado={ESTADOS_FORM.EDICION}
                reg={fichaEqv.reg}
                cancel={() =>
                    this.setState({
                        fichaEqv: {
                            open: false,
                            reg: null,
                        },
                    })
                }
            />
        );
    }

    renderModalImage() {
        const { modalImage } = this.state;
        return (
            <Modal
                isOpen={modalImage.open}
                className={cls('modal-dialog modal-image')}
                contentLabel='Modal'
                overlayClassName='modal-overlay'
                onRequestClose={this.handleCloseModal}
                ariaHideApp={false}
                shouldCloseOnEsc
                shouldCloseOnOverlayClick={false}
            >
                <div>
                    <div
                        style={{
                            backgroundColor: '#e8eaed',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end',
                        }}
                    >
                        <Button
                            icon
                            iconCls={'ms-Icon ms-Icon--Cancel icon'}
                            onClick={this.handleCloseModal}
                        />
                    </div>
                    <div>
                        <ByteImage
                            class='img-fluid'
                            src={`${SERVER}/Articulos/GetImagenERP/${modalImage.refSkrit}/0/1/0/0`}
                            default={'/Styles/img/default-img.svg'}
                        />
                    </div>
                </div>
            </Modal>
        );
    }

    render() {
        return (
            <Fragment>
                {this.renderBody()}
                {this.renderArticuloCesta()}
                {this.renderStocks()}
                {this.renderOEM()}
                {this.renderEquiv()}
                {this.renderModalImage()}
            </Fragment>
        );
    }
}

export default withSizes(getBreakpoints)(
    connect(mapStateToProps, mapDispatchToProps)(Articulos)
);
